import { render, staticRenderFns } from "./platformSelecter.vue?vue&type=template&id=100131c0&scoped=true&"
import script from "./platformSelecter.vue?vue&type=script&lang=js&"
export * from "./platformSelecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100131c0",
  null
  
)

export default component.exports